import CheckBoxFilter from "./CheckBoxFilter";
import RangeFilter from "./RangeFilter";
import SwitchFilter from "./SwitchFilter";
import SelectFilter from "./SelectFilter";
import RangeDateFilter from "./RangeDateFilter";
import InputFilter from "./InputFilter";
import {useState} from "react";
import {FilterTypes} from "./FilterTypes";


const Filters = ({filters, isOnModal, setSearchStatus, searchStatus, className = ''}) => {
    const [paramBeforeSearch, setParamBeforeSearch] = useState([])

    const changeFilterParam = (key, value) => {
        setParamBeforeSearch((prevTest) => {
            let updatedTest = [...prevTest];

            const existingIndex = updatedTest.findIndex(item => item.name === key);

            if (value !== undefined && value !== null) {
                if (existingIndex > -1) {
                    updatedTest[existingIndex] = {
                        name: key,
                        value: value
                    };
                } else {
                    updatedTest.push({
                        name: key,
                        value: value
                    });
                }
            } else if (existingIndex > -1) {
                updatedTest[existingIndex] = {
                    name: key,
                    value: ""
                };
            }

            return updatedTest;
        });
    };


    return filters.map((filter, index) => {
        switch (parseInt(filter?.input_type)) {
            case FilterTypes.CheckBox:
                return <CheckBoxFilter data={filter} key={index}/>
            case FilterTypes.RangeDate:
                return <RangeDateFilter data={filter} key={index}/>;
            case FilterTypes.RangeNumber:
                return <RangeFilter data={filter} key={index} isOnModal={isOnModal}/>
            case FilterTypes.Select:
                return <SelectFilter data={filter} key={index} className={className} isOnModal={isOnModal}
                                     filterParam={paramBeforeSearch}
                                     changeFilterParam={changeFilterParam}
                                     searchStatus={searchStatus}
                                     setSearchStatus={setSearchStatus}
                />;
            case FilterTypes.Switch:
                return <SwitchFilter data={filter} key={index}/>;
            case FilterTypes.Input:
                return <InputFilter data={filter} key={index} className={className} isOnModal={isOnModal}
                                    filterParam={paramBeforeSearch}
                                    changeFilterParam={changeFilterParam}
                                    searchStatus={searchStatus}
                                    setSearchStatus={setSearchStatus}/>;
        }
    })
};

export default Filters;
